import { CompanyTheme } from '../../api/types';
import type { ThemeComponents } from '../context';
import CardWithHeader from '../default/CardWithHeader';
import makeThemeComponents from '../makeThemeComponents';
import Carousel from '../porsche/Carousel';
import ConfiguratorDropdown from '../porsche/Configurator/Dropdown';
import ConfiguratorLayout from '../porsche/Configurator/Layout';
import ConfiguratorSubHeader from '../porsche/Configurator/SubHeader';
import ConsentModal from '../porsche/ConsentModal';
import Dropdown from '../porsche/Dropdown';
import FinderLayout from '../porsche/Finder/Layout';
import JourneySteps from '../porsche/JourneySteps';
import MobilityWebpageLayout from '../porsche/Mobility/WebPageLayout';
import Search from '../porsche/Search';
import StandardLayout from '../porsche/Standard/Layout';
import Anchor from './Anchor';
import ArrowDownIcon from './ArrowDownIcon';
import BackButton from './BackButton';
import Button from './Button';
import Calculator from './Calculator';
// client have not pay for V3
// import Carousel from './Carousel';
import Checkbox from './Checkbox/Checkbox';
import CheckboxGroup from './Checkbox/CheckboxGroup';
import CloseButton from './CloseButton';
import ConfiguratorChatIcon from './Configurator/ChatIcon';
import ConfiguratorDepositDisplay from './Configurator/DepositDisplay';
import ConfiguratorMessageButton from './Configurator/MessageButton';
import LegalText from './ConsentsAndDeclarations/LegalText';
import ErrorMessageBox from './ErrorMessageBox';
import CheckboxInputField from './Fields/CheckboxField';
import CountryField from './Fields/CountryField';
import DatePickerField from './Fields/DatePickerField';
import DisplayField from './Fields/DisplayField';
import DisplayFieldWithUTCOffset from './Fields/DisplayFieldWithUTCOffset';
import FixedRangePickerField from './Fields/FixedRangePickerField';
import GenderField from './Fields/GenderField';
import IdentityNumberField from './Fields/IdentityNumberField';
import InputField from './Fields/InputField';
import InputNumberField from './Fields/InputNumberField';
import MaritalStatusField from './Fields/MaritalStatusField';
import MultipleDraggerField from './Fields/MultipleDraggerField';
import NationalityField from './Fields/NationalityField';
import PasswordField from './Fields/PasswordField';
import PhoneAndPrefixField from './Fields/PhoneAndPrefixField';
import RaceField from './Fields/RaceField';
import RangePickerField from './Fields/RangePickerField';
import RegionField from './Fields/RegionField';
import ResidentialStatusField from './Fields/ResidentialStatusField';
import SelectField from './Fields/SelectField';
import SwitchField from './Fields/SwitchField';
import TimeRangePickerField from './Fields/TimeRangePickerField';
import TranslatedInputField from './Fields/TranslatedInputField';
import InfoMessageBox from './InfoMessageBox';
import Input from './Input';
import ListItem from './ListItem';
import LoadingSpinner from './LoadingSpinner';
import Modal from './Modal';
import notification from './notification';
import PageWithHeader from './PageWithHeader';
import PaginatedTableWithContext from './PaginatedTableWithContext';
import Pagination from './Pagination';
import Popconfirm from './Popconfirm';
import PorscheGlobalStyles from './PorscheV3GlobalStyles';
import Radio from './Radio/Radio';
import RadioGroup from './Radio/RadioGroup';
import RangePicker from './RangePicker';
import Select from './Select';
import Steps from './Steps';
import Tabs from './Tabs';
import TimePicker from './TimePicker';
import Title from './Title';
import Tooltip from './Tooltip';
import VehicleCarousel from './VehicleCarousel/VehicleCarousel';
import WarningMessageBox from './WarningMessageBox';

const PorscheThemeV3: ThemeComponents = {
    theme: CompanyTheme.PorscheV3,
    gutter: {
        testDriveModal: [14, 0],
    },
    Input,
    ConfiguratorDropdown,
    ConfiguratorSubHeader,
    ConfiguratorMessageButton,
    ConfiguratorChatIcon,
    ConfiguratorDepositDisplay,
    PageWithHeader,
    Dropdown,
    Select,
    StandardLayout,
    ConfiguratorLayout,
    Button,
    Title,
    MobilityWebpageLayout,
    BackButton,
    CloseButton,
    ComparisonButton: Button,
    FinderLayout,
    Checkbox,
    CheckboxGroup,
    RangePicker,
    TimePicker,
    FormFields: {
        RangePickerField,
        FixedRangePickerField,
        SelectField,
        InputField,
        InputNumberField,
        DatePickerField,
        IdentityNumberField,
        NationalityField,
        PhoneAndPrefixField,
        RegionField,
        CountryField,
        MultipleDraggerField,
        TimePickerField: TimeRangePickerField,
        RaceField,
        GenderField,
        ResidentialStatusField,
        MaritalStatusField,
        TranslatedInputField,
        CheckboxField: CheckboxInputField,
        SwitchField,
        DisplayField,
        PasswordField,
        DisplayFieldWithUTCOffset,
    },
    LoadingSpinner,
    Modal,
    ConsentModal,
    notification,
    Radio,
    RadioGroup,
    CardWithHeader,
    Steps,
    Search,
    ErrorMessageBox,
    InfoMessageBox,
    WarningMessageBox,
    JourneySteps,
    PaginatedTableWithContext,
    Popconfirm,
    Carousel,
    Pagination,
    Tooltip,
    Calculator,
    ListItem,
    Tabs,
    Anchor,
    LegalText,
    ArrowDownIcon,
    VehicleCarousel,
};

export default makeThemeComponents('PorscheV3ThemeProvider', PorscheThemeV3, PorscheGlobalStyles, true);
